import React from 'react';

import { Separator } from '@/components/ui/separator';
import { PRIMARY_ACTIONS } from '../../../constants';
import Button from './Button';
import Dropdown from './Dropdown';

const ActionToolbar = () => (
  <div className="flex justify-end p-3 border-b">
    <div className="flex items-center gap-1">
      {PRIMARY_ACTIONS.map((action) => (
        <Button key={action.label} {...action} />
      ))}

      <Separator
        className="data-[orientation=vertical]:h-6 mx-2"
        orientation="vertical"
      />

      <Dropdown />
    </div>
  </div>
);

export default ActionToolbar;
